import { Box, Typography } from '@mui/material';
import {
  blockActions,
  blockActionsIcons,
} from 'components/BlocksList/constants';
import { useBlocksPageV2Styles } from 'components/BlocksList/styles';

export const BlocksActionHeaderTab = ({
  tab,
  activeTab,
  setActiveTab,
  getTabCounter,
}) => {
  const { classes } = useBlocksPageV2Styles();
  const isTabDisabled = (tabValue) => tabValue === activeTab;

  const tabClassName = (tabValue) =>
    blockActions[tabValue] === activeTab
      ? `${classes.tab} ${classes.activeTab}`
      : classes.tab;

  const handleTabClick = (tabValue) => {
    if (!isTabDisabled(tabValue)) {
      setActiveTab(tabValue);
    }
  };

  const tabValue = blockActions[tab];

  return (
    <Box
      className={`${tabClassName(tab)} ${
        activeTab === tabValue ? classes.disabledTab : ''
      }`}
      key={tab}
      title={tabValue}
      onClick={() => handleTabClick(tabValue)}
      disabled={isTabDisabled(tabValue)}
    >
      {blockActionsIcons[tab]}
      <Typography component="span" className={classes.label}>
        {tabValue}
      </Typography>
      <Box className={classes.tabCounter}>{getTabCounter(tabValue)}</Box>
    </Box>
  );
};
